// Voice → gender mapping for the OpenAI TTS voices used in Interview Practice.
// Source: OpenAI's recommended voice characterizations.

export const VOICE_GENDER = {
  alloy: "male",
  ash: "male",
  echo: "male",
  fable: "male",
  onyx: "male",
  // female
  nova: "female",
  shimmer: "female",
  sage: "female",
  coral: "female",
};

export const genderForVoice = (voice) => VOICE_GENDER[voice] || "male";
